import DingsSaga from "./saga";

import IConfig from "interfaces/IConfig";
import store from "rootStore";

export const moduleName = "Dings";
export const url = "/dings";

// Endpoints only (no routes/pages yet), so the saga is always injected.
const getConfig = () => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    store.injectSaga?.("DingsSaga", DingsSaga);

    return config;
};

export default getConfig;
